import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type StopIconProps = {
  size?: number
  color?: string
  className?: string
}

export const StopIcon = ({
  size = 14,
  color = tokenVar('colors.status.error'),
  className,
}: StopIconProps) => (
  <svg
    aria-label='Stop'
    className={className}
    fill='none'
    height={size}
    role='img'
    viewBox='0 0 14 14'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect fill={color} height='10' rx='1' width='10' x='2' y='2' />
  </svg>
)
